export const fileToBase64 = (file: File): Promise<string> => {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {
      if (typeof reader.result === "string") {
        resolve(reader.result);
      } else {
        reject(new Error("FileReader result is not a string"));
      }
    };

    reader.onerror = () => {
      reject(reader.error);
    };
  });
};

export const fileDownloadFromUrl = (url: string, fileName: string) => {
  const anchorElement = document.createElement("a");
  anchorElement.href = url;
  anchorElement.setAttribute("download", fileName);
  anchorElement.style.display = "none";
  document.body.appendChild(anchorElement);
  anchorElement.click();
};
